import React, {useState} from 'react';
import {Route, Routes} from "react-router-dom";
import SuvomborlaridetailsSahifa from "./SuvomborlaridetailsSahifa";
import SuvomborlariSahifa from "./SuvomborlariSahifa";


function Index(props) {
    const [ombor,setOmbor] = useState({nomi:"SUV OMBOR",location:[41.16819665492738, 64.10930127269988]})
    return (
        <Routes>
            <Route path="/" element={<SuvomborlariSahifa setOmbor={setOmbor}/> }/>
            <Route path=":omborId" element={<SuvomborlaridetailsSahifa ombor={ombor} setOmbor={setOmbor}/>} />
        </Routes>
    );
}

export default Index;